import React from 'react';
import { noop, times } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/call-list';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callWidgetItemDetailSummary as CallWidgetItemDetailSummary } from 'ui/views/widgets/callWidgetItemDetailSummary';
 *
 * // render
 * <CallWidgetItemDetailSummary propName='propValue'/>
 */

export const callWidgetItemDetailSummarySuccess = ( props ) => {

    return (
        <div className='ui-call-widget-item-detail-summary'>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ { ...layoutConfig, dimensions: { padding: ' 10px 10px 0px '} } }
                tableResponse={ props.componentData }
                classNameTable = { 'ui-call-widget-item-detail-summary__table-container-top' }
                onActionClick={ props.onActionClick }

                /**
                 * updateTableOnChange={ true }
                 * this value has been kept true to update mark resolved action in the table
                 */
                updateTableOnChange={ true }
            />
        </div>
    );
};

// set display name
callWidgetItemDetailSummarySuccess.displayName = 'callWidgetItemDetailSummarySuccess';

// set default props
callWidgetItemDetailSummarySuccess.defaultProps = {
    componentData: {},
    layoutConfig: {},
    onActionClick: noop,
};

// prop types
callWidgetItemDetailSummarySuccess.propTypes = {};

// preloader view
export const callWidgetItemDetailSummaryPreloader = ( { columnlength = 8 } ) => {

    return (
        <div className='ui-call-widget-item-detail-summary-preloader'>
            <div className='ui-call-widget-item-detail-summary-preloader__head'>
                {
                    times( columnlength ).map( colIndex => {
                        return (
                            <div key={ colIndex } className='ui-call-widget-item-detail-summary-preloader__head__cell'>
                                <div className='ui-call-widget-item-detail-summary-preloader__head__cell__value' />
                            </div>
                        );
                    } )
                }
            </div>

            <div className='ui-call-widget-item-detail-summary-preloader__body'>
                <div className='ui-call-widget-item-detail-summary-preloader__body__row'>
                    {
                        times( columnlength ).map( colIndex => {
                            return (
                                <div key={ colIndex } className='ui-call-widget-item-detail-summary-preloader__body__row__cell'>
                                    <div className='ui-call-widget-item-detail-summary-preloader__body__row__cell__value' />
                                    <div className='ui-call-widget-item-detail-summary-preloader__body__row__cell__value' />
                                </div>
                            );
                        } )
                    }
                </div>
            </div>
        </div>
    );
};

// set display name
callWidgetItemDetailSummaryPreloader.displayName = 'callWidgetItemDetailSummaryPreloader';

// set default props
callWidgetItemDetailSummaryPreloader.defaultProps = {};

// prop types
callWidgetItemDetailSummaryPreloader.propTypes = {};

export const callWidgetItemDetailSummary = withNetworkState( callWidgetItemDetailSummaryPreloader, callWidgetItemDetailSummarySuccess );
